// todo research behaviour in reject scenarious
/**
 * Refresh access token via WebPos Sales SDK.
 * @function refreshToken
 * @returns {Promise} Promise object represents access token
 */
export default function refreshToken() {
    return window.webPosSalesSdk.requestToNewToken().then((response) => {
        return Promise.resolve(response.postData.access_token);
    });
}
